<div class="maintenance-container">

    <div class="maintenance-card">

        <h1>This Page is Under Maintenance</h1>

        <p>
            Unable to access this page at the moment.
        </p>

        <p class="suggestion">
            Please try after some time or place your order over the phone.
        </p>

    </div>

</div>